import { EpisodeDetailsFragmentFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useReadPlayerBaseInfo } from '@/scenarios/legacy-player/components/player-manager/hooks/use-read-player-base-info';

export function useNextEpisode(contentId: string): EpisodeDetailsFragmentFragment | undefined {
    const data = useReadPlayerBaseInfo(contentId);

    if (data?.content?.__typename !== 'Episode') {
        return undefined;
    }

    const nextEpisode = data.content.neighbourhoodInSeries?.items?.[0];

    if (nextEpisode?.viewOption?.watchabilityStatus !== 'WATCHABLE') {
        return;
    }

    return nextEpisode || undefined;
}
